import { render, staticRenderFns } from "./DialogOtherCost.vue?vue&type=template&id=1b3c188f"
import script from "./DialogOtherCost.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogOtherCost.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports